<template>
  <div
    class="tw:w-full tw:bg-red-600 tw:px-4 tw:py-2 tw:flex tw:items-center tw:justify-center tw:gap-4 max-payment-bar-height"
  >
    <span class="tw:text-white tw:body-1 tw:line-clamp-2">
      {{ trans._notifications.overdue }}
    </span>

    <EdroneButton :loading="isLoading" size="medium" @click="mutation.mutate">
      {{ trans._notifications.payNow }}
    </EdroneButton>
  </div>
</template>

<script lang="ts" setup>
import EdroneButton from "edrone-components/EdroneButton.vue";
import { ref } from "vue";
import { PAYMENT_BAR_HEIGHT } from "vue-app/types/enums";
import { useMutation } from "@tanstack/vue-query";
import { getStripeSession } from "vue-app/api/BillingService";
import { useRouter } from "vue-router";

const isLoading = ref(false);
const router = useRouter();
const mutation = useMutation({
  mutationFn: getStripeSession,
  onMutate: () => {
    isLoading.value = true;
  },
  onSuccess: (data) => {
    if (data.response.rejectReason === "CUSTOMER_NOT_FOUND") {
      router.push({ name: "PageAccountBilling" });
      return;
    }

    window.open(data.response.url, "_blank");
  },
  onError: () => {
    window.showToast(window._trans._notifications.cantOpen, "error");
  },
  onSettled: () => {
    isLoading.value = false;
  },
});

const paymentBarHeightCss = `${PAYMENT_BAR_HEIGHT}rem`;
</script>

<style scoped>
.max-payment-bar-height {
  max-height: v-bind(paymentBarHeightCss);
}
</style>
